import FontPicker from 'react-fontpicker-ts';
import { jsx as _jsx } from "react/jsx-runtime";

const FontsLoader = _ref => {
  let {
    loadFonts = []
  } = _ref;
  if (!loadFonts.length) return null;
  return /*#__PURE__*/_jsx(FontPicker, {
    loadAllVariants: true,
    loadFonts: loadFonts,
    loaderOnly: true
  });
};

export default FontsLoader;